import { use_slice_generation } from '@/hooks/store/use_slices';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';

interface PROPS {
  field: FIELD__base;
  edges_to: boolean;
}

export function G_GRAPH__handle_edges_amount({ field, edges_to }: PROPS) {
  const { generation_current } = use_slice_generation(['generation_current']);

  function get_text_edges_amount() {
    let { graph } = generation_current.tool;

    let edges = edges_to ? graph.edges__get_to([field]) : graph.edges__get_from([field]);

    if (edges.length == 0) return '';
    return `${edges.length}`;
  }

  return <span className="flex-center size-full text-black font-bold text-[0.35rem] ">{get_text_edges_amount()}</span>;
}
